export default "__VITE_ASSET__BCaj32wH__"